import React from "react";
import Button from "../components/Button/Button";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

function CustomerResultsSection() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <div className="w-full bg-white py-20" ref={ref}>
      {/* Heading */}
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={inView ? { y: 0, opacity: 1 } : {}}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="max-w-7xl mx-auto px-6 flex flex-col items-center text-center mb-16"
      >
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
          Results from our customers
        </h2>
      </motion.div>

      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Side: Image */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          className="flex-1 flex justify-center"
        >
          <img
            src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50d0ebaf3c731b9d82c69_Group%201000005159.png"
            alt="ROI Image"
          />
        </motion.div>

        {/* Right Side: Testimonial */}
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          className="flex-1"
        >
          <div className="flex flex-col items-start text-left">
            {/* Avatar */}
            <div className="flex flex-col items-start gap-4 mb-6">
              <img
                src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cc7f6d7fe4bb93b0f64_Avatar%20Image%202.png"
                alt="Customer Avatar"
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="grid gap-2">
                <h4 className="font-semibold text-[#7f56d9]">Micheal Miller</h4>
                <p className="text-sm text-gray-500">Director of Operations</p>
              </div>
            </div>

            {/* Quote */}
            <p className="text-gray-600 mb-8">
              “On Average{" "}
              <span className="font-semibold text-gray-800">
                we’re seeing a 600 - 800% ROI from Zola.
              </span>
              Depending on location. The fact that I can measure the impact is
              one of my favorite parts. Being able to{" "}
              <span className="font-semibold text-gray-800">
                see what I’m spending vs. what I’m getting back
              </span>{" "}
              is awesome”.
            </p>

            {/* Buttons */}
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="flex gap-4"
            >
              <Button variant="secondary" calendly>Book a demo</Button>
              <Button variant="primary">Get started</Button>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default CustomerResultsSection;
